import { DashboardEventAttendees } from '@cmp-src/components/meeting/DashboardMeetingAttendees/DashboardEventAttendees';
import { ISchedule } from '@gettactic/api';
import {
  Tabs,
  TabsContent,
  TabsList,
  TabsTrigger
} from '@v2/components/ui/tabs';
import sanitizeHtml from 'sanitize-html';
import { TypographyStylesProvider } from '@mantine/core';
import { Badge } from '@v2/components/ui/badge';
import { IResource, Tag } from '@gettactic/api';

export const RoomData = ({
  schedule,
  resource
}: {
  schedule: ISchedule;
  resource: IResource | undefined;
}) => {
  return (
    <Tabs defaultValue="attendees">
      <TabsList className="font-bold ">
        <TabsTrigger value="attendees">
          Attendees ({schedule.slots.length})
        </TabsTrigger>
        <TabsTrigger value="amenities">Amenities</TabsTrigger>
      </TabsList>
      <TabsContent value="attendees">
        <DashboardEventAttendees slots={schedule.slots} />
      </TabsContent>
      <TabsContent value="amenities">
        <Amenities
          descriptions={resource?.description}
          amenities={resource?.tags}
        />
      </TabsContent>
    </Tabs>
  );
};

const Amenities = ({
  amenities,
  descriptions
}: { amenities: Tag[] | undefined; descriptions: string | undefined | null }) => {
  if (!amenities || amenities.length === 0) {
    if (!descriptions) {
      return <div>No amenities listed yet</div>;
    }
    return (
      <div className="">
        <TypographyStylesProvider>
          <div
            // biome-ignore lint/security/noDangerouslySetInnerHtml: <this is intentional as description may be markdown>
            dangerouslySetInnerHTML={{
              __html: sanitizeHtml(descriptions, {
                allowedClasses: { span: ['bg-yellow-400'] }
              })
            }}
          />
        </TypographyStylesProvider>
      </div>
    );
  }
  const amenitiesByCategory = amenities.reduce(
    (acc, amenity) => {
      const category = amenity.category;
      if (!acc[category]) {
        acc[category] = [];
      }
      acc[category].push(amenity);
      return acc;
    },
    {} as Record<string, Tag[]>
  );

  return (
    <div className="pt-6 flex flex-col gap-2">
      {Object.entries(amenitiesByCategory).map(([type, amenities]) => (
        <div key={type} className="flex flex-row gap-2 flex-wrap items-center">
          <div className="font-bold">{type}: </div>
          {amenities.map((amenity) => (
            <div key={amenity.id}>
              <Badge variant={'outline'} key={amenity.id} className="text-md">
                {amenity.name}
              </Badge>
            </div>
          ))}
        </div>
      ))}
    </div>
  );
};
